import * as types from './LayoutActionType'
const initialState = {
  userList: [],
  }
const LayoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_LIST:
      return {
        ...state,
        userList: action.payload
      }
       default:
      return state;
  }
};

export default LayoutReducer;
